import {
  Dialog,
  DialogHeader,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";

import { useState } from "react";
import MfaAddEmail from "../components/mfa/mfa-add-email";
import EnableMfa from "@/pages/components/mfa/mfa-enable";
import RequestOTP from "@/pages/components/mfa/mfa-request-otp";
import VerifyOTP from "@/pages/components/mfa/mfa-verify-otp";
import MfaSuccess from "@/pages/components/mfa/mfa-success";
import { MFAContext, MfaViewState } from "@/context/mfa-provider";
import useUserInfo from "@/hooks/use-user-info";
import DisableMfa from "../components/mfa/mfa-disable";
import { STORAGE_KEY } from "@/constants";

const MfaContainer = ({
  open,
  onOpenChange,
  logDialogName,
  logTrigger,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  logDialogName?: string;
  logTrigger?: string;
}) => {
  const sessionDataRaw = sessionStorage.getItem(STORAGE_KEY.AUTH_DATA);
  const sessionData = sessionDataRaw ? JSON.parse(sessionDataRaw) : undefined;
  // console.log("Session Data:", sessionData?.user);

  const userInfo = useUserInfo();

  const [signature, setSignature] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(userInfo.email ?? null);
  const [viewState, setViewState] = useState(
    sessionData?.user?.is_mfa_enabled
      ? MfaViewState.DISABLE
      : MfaViewState.ENABLE,
  );

  const handleOpenChangeReset = (open: boolean) => {
    if (!open) {
      setViewState(
        sessionData?.user?.is_mfa_enabled
          ? MfaViewState.DISABLE
          : MfaViewState.ENABLE,
      );
    }
    onOpenChange(open);
  };

  const renderContent = () => {
    switch (viewState) {
      case MfaViewState.DISABLE:
        return <DisableMfa />;
      case MfaViewState.ENABLE:
        return <EnableMfa />;
      case MfaViewState.ADD_EMAIL:
        return <MfaAddEmail />;
      case MfaViewState.REQUEST_OTP:
        return <RequestOTP />;
      case MfaViewState.SEND_OTP:
        return <VerifyOTP />;
      case MfaViewState.SUCCESS:
        return <MfaSuccess />;
      case MfaViewState.COMPLETE:
        handleOpenChangeReset(false);
        return null;
      default:
        handleOpenChangeReset(false);
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={handleOpenChangeReset}
      logDialogName={logDialogName}
      logTrigger={logTrigger}
    >
      <DialogContent
        className="h-[600px] max-w-[425px]"
        logDialogName={logDialogName}
      >
        <DialogHeader className="h-1 w-full">
          <DialogTitle>Multi-Factor Authentication</DialogTitle>
        </DialogHeader>

        <div className="flex size-auto flex-col items-center justify-center">
          <MFAContext.Provider
            value={{
              viewState,
              setViewState,
              email,
              setEmail,
              signature,
              setSignature,
            }}
          >
            {renderContent()}
          </MFAContext.Provider>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MfaContainer;
